import {
  SlTab
} from "./chunk.JWRXQGAC.js";

// src/components/tab/tab.ts
var tab_default = SlTab;
SlTab.define("sl-tab");

export {
  tab_default
};
